import { useEffect, useState } from "react";
import api from "@/lib/api";
import GenericCrudPage from "./GenericCrudPage";

const STATUS = [
  { value: "issued", label: "Issued" },
  { value: "in_progress", label: "In Progress" },
  { value: "completed", label: "Completed" },
  { value: "cancelled", label: "Cancelled" },
];

export default function WorkOrdersPage() {
  const [projects, setProjects] = useState([]);
  const [vendors, setVendors] = useState([]);
  useEffect(() => {
    api.get("/projects").then((r) => setProjects(r.data));
    api.get("/vendors").then((r) => setVendors(r.data));
  }, []);

  return (
    <GenericCrudPage
      testid="workorders"
      overline="OPERATIONS"
      title="Work Orders"
      description="Track work orders across projects and vendors."
      endpoint="/work-orders"
      defaults={{ wo_number: "", project_id: "", vendor_id: "", description: "", amount: 0, issue_date: "", status: "issued" }}
      fields={[
        { name: "wo_number", label: "WO Number", type: "text" },
        { name: "status", label: "Status", type: "select", options: STATUS },
        { name: "project_id", label: "Project", type: "select", options: projects.map((p) => ({ value: p.id, label: p.name })) },
        { name: "vendor_id", label: "Vendor", type: "select", options: vendors.map((v) => ({ value: v.id, label: v.name })) },
        { name: "amount", label: "Amount (₹)", type: "number" },
        { name: "issue_date", label: "Issue Date", type: "date" },
        { name: "description", label: "Description", type: "textarea", colSpan: 2 },
      ]}
      columns={["wo_number", "description", "amount", "status", "issue_date"]}
    />
  );
}
